import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { VcsAgentPoolView } from "../../types";

const VCSAgentPoolsTableNameCell = ({
  item: vcsAgentPool,
  ...cellProps
}: TableSimpleCellProps<VcsAgentPoolView>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellLink href={`./${vcsAgentPool.id}`}>{vcsAgentPool.name}</TableCellLink>
    </TableSimpleCell>
  );
};

export default VCSAgentPoolsTableNameCell;
